import { render, staticRenderFns } from "./WorkspaceList.vue?vue&type=template&id=f6d5f136&"
import script from "./WorkspaceList.vue?vue&type=script&lang=js&"
export * from "./WorkspaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports